/**
 * Compliance Hub - Shared Constants
 */

export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const STATUS_COLORS = {
  pending: "bg-yellow-500/20 text-yellow-400",
  in_progress: "bg-blue-500/20 text-blue-400",
  complete: "bg-green-500/20 text-green-400",
  overdue: "bg-red-500/20 text-red-400",
  critical: "bg-red-500/20 text-red-400",
  at_risk: "bg-yellow-500/20 text-yellow-400",
  scheduled: "bg-blue-500/20 text-blue-400",
  verified: "bg-green-500/20 text-green-400",
  unverified: "bg-red-500/20 text-red-400",
  partial: "bg-yellow-500/20 text-yellow-400"
};

export const TOUR_STEPS = [
  {
    id: "welcome",
    title: "Welcome to Compliance Hub Tour",
    content: "This guided tour will walk you through completing compliance workflows.",
    target: null,
    action: null
  },
  {
    id: "create-demo",
    title: "Step 1: Create Demo Data",
    content: "First, let's create some demo patients with pending compliance items.",
    target: "create-demo-btn",
    action: "click-demo"
  },
  {
    id: "overview",
    title: "Step 2: Review Compliance Score",
    content: "The Overview tab shows your overall compliance score.",
    target: "overview-tab",
    action: "navigate-overview"
  },
  {
    id: "medrec-tab",
    title: "Step 3: Medication Reconciliation",
    content: "Navigate to the Med Rec tab to see patients requiring medication reconciliation.",
    target: "medication-tab",
    action: "navigate-medrec"
  },
  {
    id: "teachback-tab",
    title: "Step 4: Family Teach-back",
    content: "Navigate to the Teach-back tab to see pending education verifications.",
    target: "teachback-tab",
    action: "navigate-teachback"
  },
  {
    id: "complete",
    title: "Tour Complete!",
    content: "You've completed the Compliance Hub tour.",
    target: null,
    action: null
  }
];
